/**
 * valueInRange
 * Returns a number within min and max according to a value between 0 and 1.
 */

export default function (minResult, maxResult, percentOfRange) {
  var range = maxResult - minResult;
  return minResult + (range * percentOfRange);
};
